import { trackAction } from '../ab_track'

export function trackShortlistAction(action, { caseId, surface, count }) {
  if (!surface) return

  trackAction(action, shortlistActionContext({ caseId, surface, count }))
}

export function shortlistActionContext({ caseId, surface, count }) {
  return {
    ...(caseId === undefined ? {} : { case_id: caseId }),
    surface,
    path: window.location.pathname,
    saved_count: count,
  }
}
